// Copyright (c) 2018, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Mutation } from 'react-apollo'
import gql from 'graphql-tag'
import moment from 'moment'
import * as Sentry from '@sentry/browser'

import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome'
import { faPiggyBank } from '@fortawesome/free-solid-svg-icons'

import {
  SpanWithData,
  LabelledDetail as Detail,
  Modal,
  Card,
  Grid,
  NavLink,
  Button
} from '../'

const MUTATION_IDENTITYBANKACCOUNT = gql`
  mutation($input: IdentityBankAccountMutationInput!) {
    identitybankaccountMutate(input: $input) {
      identitybankaccount {
        id
        default
      }
    }
  }
`


export default class AccountDetailsModal extends Component {
  static propTypes = {
    forwardedRef: PropTypes.object.isRequired,
    identityBankAccount: PropTypes.object.isRequired
  }

  state = {
    setAsPrimaryInProgress: false
  }

  shouldComponentUpdate(nextProps, nextState) {
    return true
  }

  setAsPrimary = (identitybankaccountMutate) => {
    this.setState(
      { setAsPrimaryInProgress: true },
      () => {
        const input = {
          id: this.props.identityBankAccount.id,
          default: true
        }

        identitybankaccountMutate({ variables: { input } })
          .then(() => this.setState({ setAsPrimaryInProgress: false }))
          .catch(error => {
            this.setState({ setAsPrimaryInProgress: false })
            Sentry.captureMessage(`Failed to set bank account as identity's primary - ${error}`)
          })
      }
    )
  }

  render() {
    const { default: primaryBankAccount, ownership, status, statusReason, verifiedAt, workflowrunVerification, bankaccount } = this.props.identityBankAccount

    const details = [
      <Detail
        label='Account no.'
        detail={bankaccount.accountNumber}
        detailFontWeight='bold'
      />,
      <Detail
        label='Bank name'
        detail={<SpanWithData forField="BankAccountBankName" searchKey={bankaccount.bankName} />}
        detailFontWeight='bold'
      />,
      <Detail
        label='Branch code'
        detail={bankaccount.branchCode}
        detailFontWeight='bold'
      />,
      <Detail
        label='Type'
        detail={<SpanWithData forField="BankAccountAccountType" searchKey={bankaccount.accountType} />}
        detailFontWeight='bold'
      />,
      <Detail
        label='Beneficiary name'
        detail={bankaccount.beneficiaryName}
        detailFontWeight='bold'
      />,
      <Detail
        label='Status'
        detail={<SpanWithData forField='IdentityBankAccountStatus' searchKey={status} />}
        detailFontWeight='bold'
      />,
      <Detail
        label='Status reason'
        detail={statusReason}
        detailFontWeight='bold'
      />,
      <Detail
        label='Ownership'
        detail={<SpanWithData forField='IdentityBankAccountOwnership' searchKey={ownership} />}
        detailFontWeight='bold'
      />,
      <Detail
        label='Verified at'
        detail={verifiedAt
          ? workflowrunVerification
            ? <NavLink to={`/os/operations/general/workflows/${workflowrunVerification}`}>
                {moment(verifiedAt).format('lll')}
              </NavLink>
            : moment(verifiedAt).format('lll')
          : '-'
        }
        detailFontWeight='bold'
      />
    ]

    return (
      <Modal
        ref={this.props.forwardedRef}
        body={
          <Card
            title={
              <div className='slds-grid u-font-size-larger'>
                Bank account
                <Mutation mutation={MUTATION_IDENTITYBANKACCOUNT}>
                  {(identitybankaccountMutate, { data }) => {
                    if (primaryBankAccount ||
                      (data && data.identitybankaccountMutate.identitybankaccount.default)) {
                      return (
                        <span>
                            &nbsp;
                            |
                            &nbsp;
                            <span className='slds-text-color_weak'>PRIMARY</span>
                          </span>
                      )
                    }

                    if (status === 'VERIFIED') {
                      return (
                        <Button
                          type='brand'
                          disabled={this.state.setAsPrimaryInProgress}
                          onClick={() => this.setAsPrimary(identitybankaccountMutate)}
                          className='slds-col_bump-left u-font-weight-normal'>

                          {this.state.setAsPrimaryInProgress
                            ? 'Setting as primary...'
                            : 'Set as primary'
                          }
                        </Button>
                      )
                    }

                    return null
                  }}
                </Mutation>
              </div>
            }
            icon={
              <Icon icon={faPiggyBank} size='2x' />
            }
            body={
              <div>
                <Grid
                  items={details}
                  className='slds-m-top_small slds-m-bottom_medium'
                  itemClassName='slds-m-top_small slds-m-bottom_small slds-p-bottom_small slds-border_bottom'
                />
              </div>
            }
            paddingTRL={true}
          />
        }
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/identity-bankaccounts/AccountDetailsModal.js